import { Layout } from "react-admin";
import React from "react";
import TopAppBar from "./TopAppBar";
import LeftSidebar from "./LeftSidebar";
import SidebarMenu from "./SidebarMenu";
import Notification from "./Notification";
import PortalV2Modal from "../components/PortalV2Modal/PortalV2Modal";

const BaseLayout = (props: any) => (
  <>
  <Layout
    {...props}
    appBar={TopAppBar}
    sidebar={LeftSidebar}
    menu={SidebarMenu}
    notification={Notification}
    />
    {/* <PortalV2Modal /> */}
  </>
);

export default BaseLayout;
